import React, { useContext, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { Routes } from 'app/services/routeService/routeService'
import Assets from 'app/configs/assetConfigs'
import { IconButton } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import LeftbarItem from './LeftbarItem'
import AppContext from 'app/AppContext'
import {
  useIsInLimboPeriod,
  useIsPlacePendingActivateHasAccess,
} from 'app/auth/authHooks'
import { useIsPlaceRestricted } from 'commons/useIsPlaceRestricted'
import { usePlace } from 'commons/usePlace'
import { last } from 'ramda'
import { matchRoutes } from 'react-router-config'
import * as Actions from 'app/store/actions'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#E9EDF1',
  },
  rootDisabled: {
    backgroundColor: '#E9EDF1',
    opacity: 0.2,
  },
  messageSpringIcon: {
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  composeBtn: {
    backgroundColor: '#00B2AD',
    height: '45px',
    marginTop: '30px',
    marginBottom: '30px',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#00B2AD',
    },
  },
  active: {
    backgroundColor: 'rgba(255,255,255, 0.3)',
  },
  iconBtn: {
    '&:hover': {
      backgroundColor: 'rgba(255,255,255, 0.6)',
    },
  },
}))

export default (props) => {
  const { history } = props
  const classes = useStyles()
  const navigations = useSelector(({ fuse }) => fuse.navigation)
  const isPendingActiveMenu = useIsPlacePendingActivateHasAccess()
  const isInLimboPeriod = useIsInLimboPeriod()
  const isPlaceRestricted = useIsPlaceRestricted()
  const place = usePlace()
  const appContext = useContext(AppContext)
  const { routes } = appContext
  const dispatch = useDispatch()
  const mes_3908_place_profile = useFlag('mes_3908_place_profile')

  const isDisabled = isPendingActiveMenu || isInLimboPeriod || isPlaceRestricted

  const navigationsProfile = navigations.filter((item) => {
    return mes_3908_place_profile
      ? item.type === 'profile-info'
      : item.type === 'profile'
  })

  const navigationsWithOutProfile = navigations.filter((item) => {
    return item.type !== 'profile' && item.type !== 'profile-info'
  })

  useEffect(() => {
    const pathname = last(matchRoutes(routes, props.location.pathname))
    dispatch(Actions.setNavigationWithPath(pathname.match.path))
  }, [props.location.pathname])

  return (
    <div className="p-[6px]">
      <div
        className={clsx(
          'w-fit flex flex-col h-full rounded-8',
          isDisabled ? classes.rootDisabled : classes.root,
        )}
      >
        <IconButton
          disableRipple
          disabled={isDisabled}
          className={clsx('w-full p-7 mt-4', classes.messageSpringIcon)}
          onClick={() => history.push(Routes.notificationTimeline())}
        >
          <img src={Assets.logo} alt="messageSpringLogo" />
        </IconButton>

        <div>
          {navigationsWithOutProfile.map((item) => {
            return place.billingPageDisabled &&
              item.id === 'plans-and-billing' ? null : (
              <div key={`collapse-${item.id}`}>
                <LeftbarItem
                  history={history}
                  item={item}
                  disabled={isDisabled}
                />
              </div>
            )
          })}
        </div>
        <div className="flex flex-1 items-end mb-10">
          {navigationsProfile.map((item) => {
            return (
              <div className="w-full" key={`profile-${item.id}`}>
                <LeftbarItem
                  history={history}
                  item={item}
                  disabled={isDisabled}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
